import React from "react";
import { Container, Typography, Box, Paper, Divider, Button } from "@mui/material";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";

function TermsAndConditions() {
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <Navbar />
            <Box component="main" flex="1">
                <Container maxWidth="md" sx={{ mt: 5, mb: 4 }}>
                    <Paper elevation={3} sx={{ p: 3, borderRadius: 3 }}>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Terms and Conditions
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                            Last updated: 20 January, 2025
                        </Typography>
                        <Divider sx={{ my: 2 }} />
                        <Typography variant="h6" gutterBottom>
                            1. Introduction
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Welcome to Stallyons! These Terms and Conditions govern your use of our travel booking services and website. By using our platform, you agree to be bound by these terms. If you disagree with any part of the terms, please refrain from using our services.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            2. Booking Policies
                        </Typography>
                        <Typography variant="body1" paragraph>
                            All bookings are subject to availability and confirmation by the service provider. It is your responsibility to review the terms of the specific travel services, including cancellation policies and restrictions, before booking.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            3. Payment Terms
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Payments must be made in full at the time of booking unless otherwise stated. We accept various forms of payment, as specified on the payment page. Refunds are subject to the cancellation policy of the respective service provider.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            4. Cancellations and Refunds
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Cancellation and refund policies vary depending on the service provider. Please review the provider's specific terms before completing your booking. Stallyons is not responsible for cancellations made directly with service providers.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            5. Travel Requirements
                        </Typography>
                        <Typography variant="body1" paragraph>
                            It is your responsibility to ensure you meet all travel requirements, including obtaining valid travel documents such as passports and visas. Stallyons is not liable for any losses incurred due to failure to meet these requirements.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            6. Intellectual Property Rights
                        </Typography>
                        <Typography variant="body1" paragraph>
                            All content on this website, including text, graphics, logos, and images, is the property of Stallyons or its licensors. Unauthorized use of the content is strictly prohibited.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            7. Limitations of Liability
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Stallyons shall not be held liable for any direct, indirect, or consequential damages arising from the use of our website or services. This includes, but is not limited to, errors in bookings, service interruptions, or changes made by the service providers.
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                            8. Governing Law
                        </Typography>
                        <Typography variant="body1" paragraph>
                            These terms are governed by the laws of [Your Jurisdiction]. By using our website, you consent to the exclusive jurisdiction of the courts in [Your Jurisdiction] for any disputes arising from or related to these terms.
                        </Typography>
                        <Divider sx={{ my: 2 }} />
                    </Paper>
                </Container>
            </Box>
            <Footer />
        </Box>
    );
}

export default TermsAndConditions;
